/**
 * AgoraVideoGrid — RETIRED (SEP 4 2026, Agora removal).
 *
 * Every video path — solo, linked multi-broadcaster, and in-live games —
 * runs on LiveKit now (LiveKitLinkGrid). This file is an inert stub so the
 * remaining dead references in legacy branches keep compiling WITHOUT
 * pulling the Agora SDK into the bundle: the old static
 * `import AgoraRTC from 'agora-rtc-sdk-ng'` here was what booted the
 * Agora SDK on every page load (the Agora-SDK console noise) even though
 * nothing reachable used it.
 *
 * If this EVER renders, a legacy branch leaked — it renders nothing, and
 * the console.warn below is the breadcrumb. Deep-excision of the dead
 * call sites is scheduled for the post-beta cleanup round.
 */
export default function AgoraVideoGrid() {
  console.warn('[AGORA-KILL] retired AgoraVideoGrid rendered — a legacy branch leaked; report this');
  return null;
}
